import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import App from './app/index'
import { Provider } from 'react-redux';
import { persistor, store } from './redux/store';
import { ToastContainer } from 'react-toastify';
import { GuestTokenProvider } from './hooks/guestTokenProvider';
import { FaviconProvider } from './hooks/favIconProvider';
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<ToastContainer />
			<GuestTokenProvider>
				<FaviconProvider>
					<App />
				</FaviconProvider>

			</GuestTokenProvider>
		</PersistGate>
	</Provider>
);
if ('serviceWorker' in navigator) {
	navigator.serviceWorker.register('/service-worker.js', {
		scope: '/firebase-push-notification-scope'
	})
		.then((registration: ServiceWorkerRegistration) => {
			console.log('Service Worker registered with scope:', registration.scope);
		})
		.catch((error: Error) => {
			console.log('Service Worker registration failed:', error);
		});
}